// extracted by mini-css-extract-plugin
export default {"title":"Location_title__7u4qi","row":"Location_row__kTO6w"};